export const SONGS_IN_PROJECT_PAGE_SIZE = 30;
export const PROJECTS_LIST_PAGE_SIZE = 30;
